"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isProlongationStopped = exports.isAuthorized = exports.getSession = exports.getLifetimeModal = exports.getIdleModal = exports.getActivityTracking = void 0;
const isAuthorized = state => state.session.authorized;
exports.isAuthorized = isAuthorized;
const getSession = state => state.session.entity;
exports.getSession = getSession;
const getIdleModal = state => state.session.idleModal;
exports.getIdleModal = getIdleModal;
const getLifetimeModal = state => state.session.lifetimeModal;
exports.getLifetimeModal = getLifetimeModal;
const getActivityTracking = state => state.session.activityTracking;
exports.getActivityTracking = getActivityTracking;
const isProlongationStopped = state => state.session.idleModal || !state.session.activityTracking;
exports.isProlongationStopped = isProlongationStopped;